import React from 'react';

import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {

  },
});

const Header = ({ classes }) => {
  return(
    <div>Detail</div>
  );
};

export default withStyles(styles)(Header);



// WEBPACK FOOTER //
// ./src/components/Info/Header.jsx